export default __webpack_public_path__ + "static/media/Gwalior-fort.b9aff1f3.jpg";